import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { updateComission } from '../services/LotServices';
import { connect } from 'react-redux';
import { logoutAction } from '../redux/actions/UserActions';
import { Container, Row, Col, Card, CardBody, FormGroup, Label, Button, Input } from 'reactstrap';
import Loading from './Loading';

class ModalAssignComission extends Component {
    state = {
        comission: this.props.lot.comission !== null && this.props.lot.comission !== undefined ? this.props.lot.comission : '',
        loading: false,
    }

    handleChange = (event) => {
        this.setState({ comission: event.target.value });
    }

    close = () => {
        this.props.close();
    }

    save = async (comission) => {
        await this.setState({ loading: true });
        try {
            await updateComission({
                id: this.props.lot.id,
                comission: comission !== '' ? comission : null,
                token: this.props.sessionProps.account.token
            });
            this.close();
            toast(comission !== '' ? `Comisión asignada correctamente.` : `Comisión eliminada correctamente.`, {
                position: toast.POSITION.BOTTOM_CENTER,
                pauseOnHover: false,
                duration: 10000
            });
            await this.setState({ loading: false });
        } catch (error) {
            await this.setState({ loading: false });
            if (error !== undefined && error.response !== undefined && error.response.status === 401) {
                this.props.logout();
                this.props.history.push('/');
            }
            else {
                toast.error(`Ocurrió un error al procesar la solicitud, reintentar.`, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    pauseOnHover: false,
                    duration: 10000
                });
            }
        }
    }

    render() {
        return (
            <div className="container-modal">
                {this.state.loading && <Loading />}
                <div className="content-modal">
                    <Container>
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <div className="row">
                                            <div className="col-10">
                                                <h5 style={{ marginBottom: 0 }}>Lote {this.props.lot.id_lot}, {this.props.lot.title}</h5>
                                            </div>
                                            <div className="col-2" onClick={() => this.close()} style={{ textAlign: 'right', cursor: 'pointer' }}>
                                                <h5 style={{ marginBottom: 0 }}>X</h5>
                                            </div>
                                        </div>
                                        <hr style={{ marginTop: '0.5rem' }} />
                                        <FormGroup row>
                                            <Label className="col-md-3 col-form-label">Comisión (%)</Label>
                                            <Col md={9}>
                                                <Input name="comission" type="number" className="form-control"
                                                    placeholder="Ingrese porcentaje de comisión"
                                                    value={this.state.comission} onChange={this.handleChange} />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup className="mb-0 text-right" style={{ marginTop: '1rem' }}>
                                            <div>
                                                <Button onClick={() => this.close()} type="reset" color="secondary">
                                                    Cerrar
                                                </Button>
                                                {this.props.lot.comission !== null && this.props.lot.comission !== undefined &&
                                                    <Button onClick={() => this.save('')} color="danger" className="ml-2">
                                                        Eliminar
                                                    </Button>
                                                }
                                                <Button onClick={() => this.save(this.state.comission)} color="primary" className="ml-2">
                                                    Guardar
                                                </Button>
                                            </div>
                                        </FormGroup>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    sessionProps: state.userReducer
});

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => {
            dispatch(logoutAction());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAssignComission);
